<template>
  <div></div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    openLink() {
      if (this.$hasPermission([39, 43, 44, 45, 46, 51, 72, 73, 74, 75, 76, 93, 94, 99, 100, 153])) {
        // 是前程日本
        this.$router.push({ name: 'qcOrderList2022' });
      } else {
        // 是芥末
        this.$router.push({ name: 'jmOrderList2022' });
      }
    }
  },
  mounted() {
    this.openLink();
  },
};
</script>
<style scoped>

</style>
